import { useStore } from 'effector-react'

import {
  $totalCountOfParticipantsByDay,
  getParticipantsByDay,
  participantsByDayMounted,
  $participantsByDay,
  $participantsByDayStatistic,
} from './model'
import { ParticipantsByDayRequest } from './types'

export const useParticipantsByDayList = () => {
  const participantsByDay = useStore($participantsByDay)
  const loading = useStore(getParticipantsByDay.pending)
  const totalCountOfParticipantsByDay = useStore($totalCountOfParticipantsByDay)

  const participantsByDayStatistic = useStore($participantsByDayStatistic)

  const onChangeParticipantsByDay = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: ParticipantsByDayRequest) => {
    participantsByDayMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    participantsByDay,
    totalCountOfParticipantsByDay,
    loading,
    participantsByDayStatistic,
    onChangeParticipantsByDay,
  }
}
